import React from 'react';
import { Link } from "react-router-dom";
import { graphql, compose}  from 'react-apollo';

import { QueryAllInfoTherapist } from "../GraphQL/MutationTherapist";

import * as MESSAGES from '../Lib/Messages';
import Spinner from './Spinner';
import Notification from './Notification';
import BreadCrumb from './BreadCrumb';
import moment from "moment-timezone";

class Dashboard extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			isError: false,
			patients: []
		};

		this.state = {...this.getInitialState(), ...this.state};
	}

	getInitialState = () => ({
		therapist: {
			firstName: "",
			lastName: "",
			birthday: null,
			email: "",
			mobile: "",
			gender: "",
			address: "",
			city: "",
			state: "",
			country: "",
			updated: moment.utc().format(),
			created: moment.utc().format()
		}
	});

	componentWillReceiveProps(newProps) {
		const { therapist } = newProps;
		if(therapist) {
			this.setState({ therapist });
			if(therapist.assessments) {
				var patients = therapist.assessments.items;
				this.setState({ patients });
			}
		}
	}

	componentDidMount() {
		if(!window.navigator.onLine) {
			this.setState({ errorMessage: MESSAGES.ERROR_NETWORK_CONNECTION, isError: true });
		}
	}

	render() {
		const { loading, therapist, patients } = this.state;

		let totalAssessments = 0;
		if(patients) {
			patients.map((item, i) => {
				if(item) {
					var analysisItem = item.analysis;
					if(analysisItem) {
						totalAssessments += analysisItem.items.length;
					}
				}
			});
		}

		return (
			<section role="main" className="content-body">
				<header className="page-header">
					<h2>Dashboard</h2>
					<BreadCrumb title1="Dashboard" title2="" />
				</header>

			  	<Notification isError={this.state.isError} message={this.state.errorMessage} />

				<div className="row">
					<div className="col-lg-12">
						<section className="card">
							<div className={`card-body${(this.props.loading || loading) ? ' loading-overlay-showing' : ''}`}>
								<Spinner />

								<div className="row">
									<div className="col-xs-12 col-lg-6">
										<section className="card-group">
											<div className="widget-twitter-profile" style={{flex: 1}}>
												<div className="top-image">
												</div>
												<div className="profile-info">
													<div className="profile-picture">
														<img src={`/img/doctor.png`} alt="" />
													</div>
													<div className="profile-account">
														<h3 className="name font-weight-semibold">
														{therapist.firstName} {therapist.lastName}
														</h3>
														<span>{therapist.email}</span>
													</div>
												</div>
												<div className="profile-quote">
													<div className="form-group">
														<label className="col-lg-3 m-info">Full Name</label>
														<label className="col-lg-3 m-info">{therapist.firstName} {therapist.lastName}</label>
														<label className="col-lg-3 m-info">Birthday</label>
														<label className="col-lg-3 m-info">
															{therapist.birthday ? moment(therapist.birthday, 'MM/DD/YYYY').format('DD MMMM YYYY') : ''}
														</label>
													</div>
													<div className="form-group">
														<label className="col-lg-3 m-info">Phone</label>
														<label className="col-lg-3 m-info">{therapist.mobile}</label>
														<label className="col-lg-3 m-info">Gender</label>
														<label className="col-lg-3 m-info">{therapist.gender}</label>
													</div>

													<hr className="dotted tall" />
													<h4 className="mb-3">Address Info</h4>

													<div className="form-group">
														<label className="col-lg-3 m-info">Address</label>
														<label className="col-lg-9 m-info">{therapist.address}</label>
													</div>
													<div className="form-group">
														<label className="col-lg-3 m-info">City</label>
														<label className="col-lg-9 m-info">{therapist.city}</label>
													</div>
													<div className="form-group">
														<label className="col-lg-3 m-info">State</label>
														<label className="col-lg-3 m-info">{therapist.state}</label>
														<label className="col-lg-3 m-info">Country</label>
														<label className="col-lg-3 m-info">{therapist.country}</label>
													</div>

													<div className="quote-footer">
														Last updated: <span className="datetime">
														{therapist.updated !== undefined ? moment(therapist.updated).tz('Australia/Sydney').format('MM/DD/YYYY HH:mm') : ''}
														</span>
													</div>
												</div>
											</div>
										</section>
									</div>
									<div className="col-xs-12 col-lg-6 chart-info">
										<section className="card">
											<header className="card-header bg-primary">
												<div className="card-header-icon">
													<i className="fas fa-chart-bar"></i>
												</div>
											</header>
											<div className="card-body">
												<section className="card card-featured-bottom card-featured-primary mb-4">
													<div className="card-body">
														<div className="widget-summary">
															<div className="widget-summary-col widget-summary-col-icon">
																<div className="summary-icon bg-primary">
																	<i className="fas fa-user"></i>
																</div>
															</div>
															<div className="widget-summary-col">
																<div className="summary">
																	<h4 className="title">TOTAL PATIENTS</h4>
																	<div className="info">
																		<strong className="amount">{ patients.length }</strong>
																	</div>
																</div>
																<div className="summary-footer">
																	<Link to="/patients/list" className="text-muted text-uppercase">(VIEW ALL)</Link>
																</div>
															</div>
														</div>
													</div>
												</section>
												<section className="card card-featured-bottom card-featured-primary mb-4">
													<div className="card-body">
														<div className="widget-summary">
															<div className="widget-summary-col widget-summary-col-icon">
																<div className="summary-icon bg-primary">
																	<i className="fas fa-allergies"></i>
																</div>
															</div>
															<div className="widget-summary-col">
																<div className="summary">
																	<h4 className="title">TOTAL ASSESSMENTS</h4>
																	<div className="info">
																		<strong className="amount">{totalAssessments}</strong>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</section>
											</div>
										</section>
									</div>
								</div>
							</div>
						</section>
					</div>
				</div>
			</section>
		)
	}
}

export default compose(
	graphql(QueryAllInfoTherapist, {
		options: (props) => ({
			fetchPolicy: 'network-only',
			variables: { id: localStorage.getItem('subHandsApps') }
		}),
		props: ({ data: { getTherapist, loading } }) => ({
			therapist: getTherapist,
			loading
		})
 	}),
)(Dashboard);
